var _defs, _use, _use2, _use3, _use4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPujocategory = function SvgPujocategory(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "89.44 100.247 452.273 414.826",
    width: 445,
    height: 407.83,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.57 242.3c32.91 33.79 75.59 33.79 108.5 0 23.87-23.91 30.75-51.24 21.34-84.26-13.38-46.31-68.35-70.6-111.03-48.58-49.55 25.81-58.96 92.23-18.81 132.84Zm75.23-9.48c-19.53 10.62-42.68 4.93-60.4-15.19-12.3-14.04-14.47-44.79-3.98-62.25 15.19-25.81 49.55-33.02 73.06-15.18 31.47 23.16 26.76 73.26-8.68 92.62Z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68 332.26c0 13.29-1.08 15.18-9.76 17.08-5.79 1.14-17 7.21-24.96 13.29-47.74 36.43-37.61 118.8 17.36 142.71 68 29.99 133.82-45.92 100.55-115.38-8.68-17.84-19.89-28.47-40.87-37.96-16.64-7.59-19.17-12.15-14.83-24.29 1.81-5.32 17-6.08 131.65-6.08s129.84.76 131.65 6.08c4.34 12.14 1.81 16.7-14.83 24.29-20.97 9.49-32.19 20.12-40.87 37.96-19.89 41.75-6.14 89.57 32.19 111.59 40.15 22.77 88.25 6.45 109.59-37.2 5.79-11.77 6.87-20.12 5.79-40.61-1.81-33.78-14.11-53.52-43.76-69.46-18.81-10.25-20.62-12.15-20.62-23.92 0-17.08-5.06-26.19-18.08-33.4-15.56-8.35-268.01-8.35-282.83.38-12.66 7.21-17.37 16.32-17.37 34.92Zm50.28 133.61c-22.06 22.77-54.98 22.39-74.87-1.52-15.55-18.6-17.72-36.82-7.23-58.45 13.38-27.71 38.7-37.58 65.82-25.81 32.55 14.04 40.87 59.59 16.28 85.78Zm304.53-24.29c-10.49 41.37-57.87 54.65-86.8 24.29-24.6-25.81-16.28-70.6 15.55-85.78 14.83-7.21 38.7-4.56 52.08 5.69 15.55 11.39 24.23 36.44 19.17 55.8Z",
    id: "b"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#738288"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fillOpacity: 0,
    stroke: "#738288",
    strokeOpacity: 0
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#738288"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fillOpacity: 0,
    stroke: "#738288",
    strokeOpacity: 0
  })));
};
export default SvgPujocategory;